//Styles
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"

export default function DragOverlayQuestion({ draggedObject }) {
  let description = "Unknown type"

  if (draggedObject?.formulaOrder?.question) {
    description = draggedObject.formulaOrder.question?.title || "No title"
  } else if (draggedObject?.object) {
    description = draggedObject.object?.question?.text || "No title"
  }

  return (
    <div className={myStyles.dragOverlyGeneral}>
      {description.length > 100
        ? description.substring(0, 100) + "..."
        : description}
    </div>
  )
}
